import styled from 'styled-components';

/** Shared upload trigger used anywhere the enterprise Asset Library upload modal is available. */
export const UploadButton = styled.button`
  padding: 8px 20px;
  border: 1px solid #0b99e6;
  border-radius: 6px;
  background: #0b99e6;
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #0988cf;
  }
`;
